import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { PonchoUIModule } from '@poncho/ui';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FeatureToggleDirective } from '../../directives/feature-toggle.directive';
import { ToastrService } from '@app/core/services/notification/toastr.service';
import { OutletTiming } from '@app/shared/models/api-response/outlet-timing-response';

@Component({
    selector: 'app-deliver-later-pop-up',
    templateUrl: './deliver-later-pop-up.component.html',
    styleUrls: ['./deliver-later-pop-up.component.scss'],
    standalone: true,
    imports: [FeatureToggleDirective, MatFormFieldModule, MatSelectModule, FormsModule, MatOptionModule, PonchoUIModule, MatIconModule, MatRadioModule, DatePipe, MatDialogModule]
})
export class DeliverLaterPopUpComponent implements OnInit {
    
    outlet: {
        interval: number;
        outlet_id: number;
        outlet_name: string;
        outlet_timings: OutletTiming;
        preorder_available: boolean;
        active: boolean;
        open: boolean;
        dflt: boolean;
    };

    cartEta: string;
    isPickupSelected: boolean;
    preorderTime: number | null;
    preorderTimeRange: number[];
    selectedTime: number | null;
    isPrimaryBrandPreorderOnly: boolean;
    preorderInterval = 1800 * 1000; // 30 mins

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any, 
        private toastrService: ToastrService,
        public dialogRef: MatDialogRef<DeliverLaterPopUpComponent>
    ) {}

    ngOnInit() {
        const { preorder, preorderTimeRange, outlet, isPickupSelected, cartEta, primaryBrandData } = this.data;
        this.outlet = outlet;
        this.preorderTime = preorder.time;
        this.isPickupSelected = isPickupSelected;
        this.preorderTimeRange = preorderTimeRange;
        this.selectedTime = this.preorderTime || undefined;

        // in the case, a brand is in preorder state, user can remove this brand and order now
        // but in this case, user have to select slot compulsary, there is no option for order now
        this.isPrimaryBrandPreorderOnly = primaryBrandData?.state === 'preorder';

        if (cartEta) {
            this.cartEta = cartEta[1] ? (cartEta[1] - cartEta[0] ? `${cartEta[0]}-${cartEta[1]}` : `${cartEta[0]}`) : '45';
        }
    }

    updatePreorderTime() {
        if (this.isPrimaryBrandPreorderOnly && !this.selectedTime) {
            this.toastrService.openSnackBar("Please Select Delivery Slot!", "OKAY");
            return;
        }
        
        this.dialogRef.close(this.selectedTime);
    }

    selectedTimeRange(time: number) {
        this.selectedTime = time;
    }

    close() {
        this.dialogRef.close(0);
    }
}
